import { Ref, useEffect, useState } from "react";
import { SxProps, TextField } from "@mui/material";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export interface UINumberListProps {
    inputRef?: Ref<AppGlueAny>;
    value: number[];
    decimals?: boolean;
    sx?: SxProps;
    error?: string;

    onChange(value: number[]): void;
}

export function UINumberList(props: UINumberListProps) {
    let [val, setVal] = useState<string[]>([]);

    useEffect(() => {
        setVal(
            props.value.map((v) => {
                return v + "";
            }),
        );
    }, [props.value]);

    return (
        <TextField
            sx={props.sx}
            inputRef={props.inputRef}
            value={val.join("\n")}
            multiline={true}
            minRows={3}
            error={Boolean(props.error)}
            onChange={(e) => setVal(e.target.value.split("\n"))}
            onBlur={() => {
                let numbers: number[] = [];

                for (let v of val) {
                    try {
                        if (props.decimals) numbers.push(Number.parseFloat(v));
                        else numbers.push(Number.parseInt(v));
                    } catch {}
                }

                props.onChange(numbers);
            }}
        />
    );
}
